<template>
  <span>
    <el-form-item label="渠道维度">
      <el-select :size="size"
      filterable
      multiple
      clearable
      collapse-tags
      placeholder="所有渠道"
      v-model="channelValue">
        <el-option
          v-for="item in channelData"
          :key="item.tag"
          :label="item.name"
          :value="item.tag"
        ></el-option>
      </el-select>
    </el-form-item>
  </span>
</template>

<script>
import { getDimensions } from '@/api/user'
export default {
  name: 'ChannelSelect',
  data() {
    return {
      channelValue: [],
      channelData: []
    }
  },
  props: {
    // 下拉框size
    size: {
      type: String,
      default() {
        return 'small'
      }
    },
    // 回调方法，传递维度数据，格式为数组
    getChannelData: Function
  },
  watch: {
    channelValue() {
      this.noticeChange()
    }
  },
  mounted() {
    this.loadChannelInfo()
  },
  // activated() {
  //   console.log('1111111111111111111')
  //   this.loadChannelInfo()
  // },
  methods: {
    loadChannelInfo() {
      this.agentValue = []
      getDimensions({ detail: false })
        .then((res) => {
          if (res.code === 2000) {
            if (res.data && res.data.length) {
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].code === window.$envUtils('VUE_APP_ROBOT_CUSTOM')) {
                  this.channelData = res.data[i].tags
                  break
                }
              }
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {})
    },
    noticeChange() {
      const dims = {}
      if (this.channelValue.length > 0) {
        dims[window.$envUtils('VUE_APP_ROBOT_CUSTOM')] = this.channelValue
      }
      this.getChannelData(dims)
    },
    /**
     * 清除所有选项
     */
    clearSelected() {
      this.channelValue = [] // 清除渠道信息
    },
    setChannelValue(channelValue_) {
      this.channelValue = []
      this.channelValue.push(...channelValue_)
    }
  }
}
</script>
